import { SVGProps } from "react";

const PlayIcon = (props: SVGProps<SVGSVGElement> & { color?: string }) => {
  return (
    <svg
      width="81"
      height="81"
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="40.8359" cy="40.5469" r="40" fill="#FF4F00" />
      <path
        d="M26.9062 23.2627C26.9065 21.1747 29.1654 19.8705 30.9736 20.9141L45.9414 29.5557L60.9102 38.1982C61.814 38.7206 62.2656 39.6338 62.2656 40.5469L62.2598 40.7178C62.2068 41.5724 61.7576 42.4058 60.9102 42.8955L45.9414 51.5371L30.9736 60.1787C29.1653 61.2223 26.9062 59.9183 26.9062 57.8301V23.2627Z"
        fill="white"
      />
    </svg>
  );
};

export { PlayIcon };
